import { Form, Formik } from 'formik';
import SelectBox from '../../shared/controls/form/selectBox';
import { CheckBox, DateBox, TextArea, TextBox } from '../../shared/controls/form';
import { validationSchemaProduct } from './productValidationSchema';
import { useSelector } from 'react-redux';
import {
  getActiveOwners,
  getGenericMasterFilteredListByKey,
  getProductReferenceLookupByKey,
} from '../../redux/selector';
import CreatableSelect from 'react-select/creatable';

const ProductForm = ({
  formData,
  selectedOptions,
  handleSubmit,
  handleChangeForm,
  handleChange,
  errormsg,
  handleChangeCheckbox,
  refs,
}) => {
  const productOwner = useSelector(getActiveOwners);
  const usageUnit = useSelector(getGenericMasterFilteredListByKey('UsageUnit'));
  const tax = useSelector(getGenericMasterFilteredListByKey('Tax'));
  const handler = useSelector(getActiveOwners);
  const vendors = useSelector(getProductReferenceLookupByKey('Vendor'));
  const manufacturer = useSelector(getProductReferenceLookupByKey('Manufacturer'));
  const productCategory = useSelector(getProductReferenceLookupByKey('ProductCategory'));
  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaProduct}
    >
      <Form>
        <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
          <div className="row gx-3">
            <div className="col-12 col-sm-12 col-md-12">
              <div className="infoBox">
                <div className="addlead-header pd_card">
                  <label htmlFor="" className="flex-div align-items-center">
                    <img className="me-2" src="../assets/quoteAi/images/quoteInfo.svg" alt="" />
                    Product Information
                  </label>
                </div>
                <div className="quoteContent leadDetailInfo ">
                  <>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label="Product Owner"
                            name={'productOwnerId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.productOwner || '--'
                                : formData?.productOwner || 'Select Product Owner'
                            }
                            isRequired={false}
                            handleSelect={handleChange}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions?.productOwnerId}
                            options={productOwner}
                            optionKeys={['userId', 'display_name']}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Product Name'}
                            name={'name'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Product Name'}
                            value={formData?.name}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            maxLength={100}
                            errormsg={errormsg?.name}
                          />
                        </div>
                      </div>

                      {/* <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label={"Code"}
                            name={"code"}
                            placeholder={
                              formData?.type === "view" ? "--" : "Enter Code"
                            }
                            value={formData?.code}
                            disabled={formData?.type === "view"}
                            handleChange={handleChangeForm}
                            maxLength={100}
                          />
                        </div>
                      </div> */}
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label="Product Code"
                            name={"productCode"}
                            value={formData?.productCode}
                            placeholder={
                              formData?.type === "view"
                                ? "--"
                                : "Enter Product Code"
                            }
                            handleChange={handleChangeForm}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <label htmlFor="memberStatusId" style={{ width: '150px' }}>
                            Vendor Name
                          </label>
                          <CreatableSelect
                            isMulti={false}
                            name="vendorId"
                            options={vendors.map((v) => ({
                              label: v.displayName,
                              value: v.id,
                            }))}
                            value={
                              formData?.vendorId
                                ? {
                                    label: formData.vendorName,
                                    value: formData.vendorId,
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, 'vendorId')
                            }
                            isDisabled={formData?.type === 'view'}
                            placeholder={
                              formData?.type === 'view'
                                ? '--'
                                : formData?.vendorName || 'Select Vendor Name'
                            }
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: '100%',
                              }),
                            }}
                          />

                          {/* <SelectBox
                            label="Vendor Name"
                            name={"vendorName"} // store the ID, not the text
                            placeholder={
                              formData?.type === "view"
                                ? formData?.vendorName || "--"
                                : "Select Vendor"
                            }
                            isRequired={false}
                            disabled={formData?.type === "view"}
                            selectedOptions={selectedOptions.vendorId}
                            optionKeys={["id", "name"]}
                            allowCreate
                          /> */}
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="dateBox">
                            <label>Sales Start Date</label>
                            {formData?.type === 'view' ? (
                              <div>
                                {formData?.salesStartDate
                                  ? new Date(formData.salesStartDate).toLocaleDateString('en-US', {
                                      year: 'numeric',
                                      month: '2-digit',
                                      day: '2-digit',
                                    })
                                  : '--'}
                              </div>
                            ) : (
                              <div className="dtBox custom-date-wrapper">
                                <DateBox
                                  name={'salesStartDate'}
                                  className="custom-date-input"
                                  placeholder={
                                    formData?.type === 'view'
                                      ? '--'
                                      : 'Sales Start Date(MM/DD/YYYY)'
                                  }
                                  value={
                                    formData?.salesStartDate
                                      ? formData?.salesStartDate.substring(0, 10)
                                      : ''
                                  }
                                  disabled={formData?.type === 'view'}
                                  handleChange={handleChangeForm}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="dateBox">
                            <label>Sales End Date</label>

                            {formData?.type === 'view' ? (
                              <div>
                                {formData?.salesEndDate
                                  ? new Date(formData.salesEndDate).toLocaleDateString('en-US', {
                                      year: 'numeric',
                                      month: '2-digit',
                                      day: '2-digit',
                                    })
                                  : '--'}
                              </div>
                            ) : (
                              <div className="dtBox custom-date-wrapper">
                                <DateBox
                                  name={'salesEndDate'}
                                  className="custom-date-input"
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Sales End Date(MM/DD/YYYY)'
                                  }
                                  value={
                                    formData?.salesEndDate
                                      ? formData?.salesEndDate.substring(0, 10)
                                      : ''
                                  }
                                  disabled={formData?.type === 'view'}
                                  handleChange={handleChangeForm}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="dateBox">
                            <label>Support Start Date</label>

                            {formData?.type === 'view' ? (
                              <div>
                                {formData?.supportStartDate
                                  ? new Date(formData.supportStartDate).toLocaleDateString(
                                      'en-US',
                                      {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                      }
                                    )
                                  : '--'}
                              </div>
                            ) : (
                              <div className="dtBox custom-date-wrapper">
                                <DateBox
                                  name={'supportStartDate'}
                                  className="custom-date-input"
                                  placeholder={
                                    formData?.type === 'view'
                                      ? '--'
                                      : 'Support Start Date(MM/DD/YYYY)'
                                  }
                                  value={
                                    formData?.supportStartDate
                                      ? formData?.supportStartDate.substring(0, 10)
                                      : ''
                                  }
                                  disabled={formData?.type === 'view'}
                                  handleChange={handleChangeForm}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="dateBox">
                            <label>Support End Date</label>

                            {formData?.type === 'view' ? (
                              <div>
                                {formData?.supportEndDate
                                  ? new Date(formData.supportEndDate).toLocaleDateString('en-US', {
                                      year: 'numeric',
                                      month: '2-digit',
                                      day: '2-digit',
                                    })
                                  : '--'}
                              </div>
                            ) : (
                              <div className="dtBox custom-date-wrapper">
                                <DateBox
                                  name={'supportEndDate'}
                                  className="custom-date-input"
                                  placeholder={
                                    formData?.type === 'view'
                                      ? '--'
                                      : 'Support End Date(MM/DD/YYYY)'
                                  }
                                  value={
                                    formData?.supportEndDate
                                      ? formData?.supportEndDate.substring(0, 10)
                                      : ''
                                  }
                                  disabled={formData?.type === 'view'}
                                  handleChange={handleChangeForm}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <label htmlFor="memberStatusId" style={{ width: '150px' }}>
                            Manufacturer
                          </label>
                          <CreatableSelect
                            isMulti={false}
                            name="manufacturerId"
                            value={
                              formData?.manufacturerId
                                ? {
                                    label: formData.manufacturer,
                                    value: formData.manufacturerId,
                                  }
                                : null
                            }
                            options={manufacturer.map((v) => ({
                              label: v.displayName,
                              value: v.id,
                            }))}
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, 'manufacturerId')
                            }
                            isDisabled={formData?.type === 'view'}
                            placeholder={
                              formData?.type === 'view'
                                ? '--'
                                : formData?.manufacturer || 'Select Manufacturer'
                            }
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: '100%',
                              }),
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <label htmlFor="memberStatusId" style={{ width: '150px' }}>
                            Product Category
                          </label>
                          <CreatableSelect
                            isMulti={false}
                            name="productCategoryId"
                            value={
                              formData?.productCategoryId
                                ? {
                                    label: formData.productCategory,
                                    value: formData.productCategoryId,
                                  }
                                : null
                            }
                            options={productCategory.map((v) => ({
                              label: v.displayName,
                              value: v.id,
                            }))}
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, 'productCategoryId')
                            }
                            isDisabled={formData?.type === 'view'}
                            placeholder={
                              formData?.type === 'view'
                                ? '--'
                                : formData?.productCategory || 'Select Product Category'
                            }
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: '100%',
                              }),
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="form-check d-flex align-items-center gap-4 ps-0">
                            <CheckBox
                              label={'Product Active'}
                              name={'productActive'}
                              checked={formData?.productActive}
                              handleChange={handleChangeCheckbox}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12">
              <div className="infoBox">
                <div className="addlead-header pd_card">
                  <label htmlFor="" className="flex-div align-items-center">
                    <img className="me-2" src="../assets/quoteAi/images/quoteInfo.svg" alt="" />
                    Price Information
                  </label>
                </div>
                <div className="quoteContent leadDetailInfo ">
                  <>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container mb-2">
                          <label className="form-label">Unit Price</label>

                          {formData?.type === 'view' ? (
                            <>
                              <span>$</span>
                              <span className="form-control-plaintext">
                                {`${formData?.unitPrice ?? '--'}`}
                              </span>
                            </>
                          ) : (
                            <div className="input-group">
                              <span className="input-group-text">$</span>
                              <input
                                type="number"
                                name="unitPrice"
                                className="form-control"
                                placeholder="Enter Unit Price"
                                min="0"
                                step="0.01"
                                value={formData?.unitPrice ?? ''}
                                onChange={handleChangeForm}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container mb-2">
                          <label className="form-label">Commission Rate</label>
                          {formData?.type === 'view' ? (
                            <>
                              <span className="form-control-plaintext">
                                {`${formData?.commissionRate ?? '--'}`}
                                <span>%</span>
                              </span>
                            </>
                          ) : (
                            <div className="input-group">
                              <span className="input-group-text">%</span>
                              <input
                                type="number"
                                name={'commissionRate'}
                                className="form-control"
                                placeholder={
                                  formData?.type === 'view' ? '--' : 'Enter Commission Rate'
                                }
                                onChange={handleChangeForm}
                                value={formData?.commissionRate ?? ''}
                                disabled={formData?.type === 'view'}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label="Tax"
                            name={'taxId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.tax || '--'
                                : formData?.tax || 'Select Tax'
                            }
                            handleSelect={handleChange}
                            isRequired={false}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions?.taxId}
                            options={tax}
                            optionKeys={['id', 'displayName']}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="form-check d-flex align-items-center gap-4 ps-0">
                            <CheckBox
                              label={'Taxable'}
                              name={'productActive'}
                              checked={formData?.productActive}
                              handleChange={handleChangeCheckbox}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12">
              <div className="infoBox">
                <div className="addlead-header pd_card">
                  <label htmlFor="" className="flex-div align-items-center">
                    <img className="me-2" src="../assets/quoteAi/images/companyInfo.svg" alt="" />
                    Stock Information
                  </label>
                </div>
                <div className="quoteContent leadDetailInfo">
                  <>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label="Usage Unit"
                            name={'usageUnitId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.usageUnit || '--'
                                : formData?.usageUnit || 'Select Usage Unit'
                            }
                            handleSelect={handleChange}
                            isRequired={false}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions?.usageUnitId}
                            options={usageUnit}
                            optionKeys={['id', 'displayName']}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-6 col-md-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label="Qty Ordered"
                            name={'quantityOrdered'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Quantity Ordered'
                            }
                            value={formData?.quantityOrdered ?? ''}
                            handleChange={handleChangeForm}
                            // errormsg={errormsg?.qtyOrdered}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-6 col-md-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label="Qty In Stock"
                            name={'quantityInStock'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Quantity In Stock'
                            }
                            value={formData?.quantityInStock ?? ''}
                            handleChange={handleChangeForm}
                            // errormsg={errormsg?.qtyInStock}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-md-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label="Qty In Demand"
                            name={'quantityInDemand'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Quantity In Demand'
                            }
                            value={formData?.quantityInDemand ?? ''}
                            handleChange={handleChangeForm}
                            // errormsg={errormsg?.qtyInDemand}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label="Handler"
                            name={'handlerId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.handler || '--'
                                : formData?.handler || 'Select Handler'
                            }
                            isRequired={false}
                            handleSelect={handleChange}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions?.handlerId}
                            options={handler}
                            optionKeys={['userId', 'display_name']}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-md-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label="Reorder Level"
                            name={'reorderLevel'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Reorder Level'}
                            value={formData?.reorderLevel ?? ''}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12">
              <div className="infoBox">
                <div className="addlead-header pd_card">
                  <label htmlFor="" className="flex-div align-items-center">
                    <img
                      className="me-2"
                      src="../assets/quoteAi/images/additionalInfo.svg"
                      alt=""
                    />
                    Additional Details
                  </label>
                </div>
                <div className="quoteContent leadDetailInfo notesLabel">
                  <>
                    <div className="row">
                      {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="input-container blockClass">
                          <TextArea
                            label={'Terms and Conditions'}
                            name={'terms'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Terms and Conditions'
                            }
                            value={formData?.terms}
                            handleChange={handleChangeForm}
                          />
                        </div>
                      </div> */}
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="input-container blockClass">
                          <TextArea
                            label={'Description'}
                            name={'description'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                            value={formData?.description}
                            handleChange={handleChangeForm}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default ProductForm;
